import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.menuTarget.style.display = 'none'
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside.bind(this))
  }

  open() {
    this.menuTarget.style.display = 'block'
    setTimeout(() => {
      document.addEventListener("click", this.closeOnClickOutside.bind(this), { once: true })
    }, 10)
  }

  close() {
    this.menuTarget.style.display = 'none'
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  toggle() {
    if (this.menuTarget.style.display === 'none') {
      this.open()
    } else {
      this.close()
    }
  }
}